export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

export function isValidSlug(slug: string): boolean {
  return SLUG_RE.test(slug);
}

/** Letters NFKD does not decompose. */
const SPECIAL: Record<string, string> = { ł: 'l', ø: 'o', ß: 'ss', đ: 'd', æ: 'ae', œ: 'oe', þ: 'th', ð: 'd' };

/** "Family Chores!" → "family-chores". Falls back to "app" for empty results. */
export function slugify(input: string): string {
  const slug = input
    .toLowerCase()
    .replace(/[łøßđæœþð]/g, (ch) => SPECIAL[ch] ?? ch)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '');
  return slug.length > 0 ? slug : 'app';
}
